import React, { useState } from "react";
import CourieButton from "@src/common/components/Button/Button";

interface Props {
  onSubmit: (text: string) => Promise<void>;
  loading: boolean;
}

export function CommentInput({ onSubmit, loading }: Props) {
  const [text, setText] = useState("");

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSubmit(trimmed).then(() => setText("")).catch(() => {});
  };

  return (
    <div className="flex flex-col gap-1">
      <textarea
        className="w-full rounded-md px-3 py-2 text-xs bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 outline-none placeholder:text-gray-400 resize-none border-none"
        rows={3}
        placeholder="Leave a comment..."
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <div className="flex justify-end">
        <CourieButton
          size="xs"
          onClick={handleSubmit}
          disabled={!text.trim()}
          isProcessing={loading}
        >
          Comment
        </CourieButton>
      </div>
    </div>
  );
}
